<template>
    <div id="MediaPlayer">
        <div class="course-live-wrap">
            <div class="media">
                <ne-player
                        v-if="state === 3 && videoAddress"
                        :config="videoConfig"
                        :videoAddress="videoAddress"
                        :onlineMemberType="onlineMemberType"
                        :onlineMemberNum="onlineMemberNum"
                        :coursePv="coursePv"
                        :watchTime="watchTime"
                        :duration="duration"
                        :controls="state === COURSE_STATE.LIVING"
                        :msgTip="msgTip"
                        :courseId="courseId"
                        @changeClarity="handleChangeTransCode"
                        @changeFullScreen="handleFullScreen"
                        @changeChannel="handleChangeChannel"
                        @clearMsgTip="handleClearMsg">
                </ne-player>
                <div class="not-living-wrap" v-if="state !== COURSE_STATE.LIVING"
                     :style="{backgroundImage: `url(${cover})`}">
                    <div :class="['not-living-tips', {'end': state > COURSE_STATE.LIVING}]">{{ notLivingTip }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import {formatter} from '@/utils/durationFormat'
    import {COURSE_STATE} from '@/constant/constants'
    import NePlayer from './NePlayer'

    const TYPES = {
        netease: {
            value: 1,
        },
        tencent: {
            value: 2,
        },
    }
    export default {
        name: '',
        props: {
            courseId: {
                type: String,
                required: true,
            },
            startTime: {
                type: [Number, String],
                required: true,
            },
            onlineMemberType: {
                type: Number,
                required: true,
            },
            onlineMemberNum: {
                type: Number,
                required: true,
            },
            coursePv: {
                type: Number,
                required: true,
            },
            channel: {
                type: String,
            },
            state: {
                type: Number,
                required: true,
            },
            cover: {
                type: String,
                default: '',
            },
            watchTime: {
                type: String,
                default:'0分钟',
            },
        },
        components: {NePlayer},
        data() {
            return {
                notLivingTip: '',
                addressTranscode: null,
                videoAddress: {},
                duration: '',
                durationInterval: null,
                videoConfig: {},
                COURSE_STATE,
                msgTip: '',
                startTimeSelf: 0,
            }
        },
        computed: {
            ...mapState('app', ['isLogin']),
            ...mapState('chat', ['messageTips']),
        },
        watch: {
            state: {
                handler: function (newVal) {
                    if (newVal === COURSE_STATE.LIVING) {
                        this.notLivingTip = '请登录来解锁直播哦'
                        this.startTimeSelf = this.startTime || new Date().getTime()
                        this.initTranscode(TYPES.netease.value).then(() => {
                            this.init()
                        })
                    } else if (newVal === COURSE_STATE.FORECAST) {
                        this.notLivingTip = '就在这里，准时等你'
                    } else if (newVal === COURSE_STATE.ENDED) {
                        clearInterval(this.durationInterval)
                        this.notLivingTip = '课程直播已结束'
                    }
                },
                immediate: true,
            },
            messageTips(newVal) {
                if (newVal) {
                    this.msgTip = newVal
                }
            },
        },
        methods: {
            ...mapActions({
                getTranscode: 'live/getTranscode',
                findCourseStatisticVo: 'live/findCourseStatisticVo',
            }),
            init() {
                if (this.isLogin) {
                    this.$store.dispatch('live/setViewHistory', {targetId: this.courseId})
                }
                this.durationInterval = setInterval(() => {
                    this.duration = formatter(Date.now() - this.startTimeSelf)
                }, 1000)
            },
            initTranscode(val) { // 初始化获取转码地址
                return this.getTranscode({
                    type: val,
                    mixId: parseInt(val) === TYPES.netease.value ? this.channel : this.courseId
                }).then((address) => {
                    this.addressTranscode = address
                    this.videoAddress = {
                        httpPullUrl: `${this.handleUrlReplace(address.transcodeHttpPullUrl['_1280'])}`,
                        hlsPullUrl: `${this.handleUrlReplace(address.transcodeHlsPullUrl['_1280'])}`,
                    }
                })
            },
            handleUrlReplace(url) {
                // 由于目前腾讯云的问题无法解决，暂时决定H5中腾讯云清晰度切换不能进行
                return url.replace('http://', 'https://').replace('_1280', '').replace('_640', '').replace('_360', '')
            },
            handleChangeTransCode(val) {
                this.$store.commit('chat/setMessageTips', '')
                this.msgTip = ''
                this.videoAddress = {
                    httpPullUrl: `${this.handleUrlReplace(this.addressTranscode.transcodeHttpPullUrl[val])}`,
                    hlsPullUrl: `${this.handleUrlReplace(this.addressTranscode.transcodeHlsPullUrl[val])}`,
                }
            },
            handleChangeChannel(val) {
                this.$store.commit('chat/setMessageTips', '')
                this.msgTip = ''
                this.initTranscode(val)
            },
            handleFullScreen() {

            },
            handleClearMsg() {
                this.$store.commit('chat/setMessageTips', '')
                this.msgTip = ''
            },
        },
        destroyed() {
            clearInterval(this.durationInterval)
        },
    }
</script>

<style lang="scss">
    @import '@/styles/media.scss';
</style>
